import axios from 'axios';
import { auth } from '@api/Firebase/Firebase';

const getToken = async () => {
    return auth.currentUser?.getIdToken();
};

const BASE_URL = 'https://krispis.fly.dev';

export const axiosPrivate = axios.create({
    baseURL: BASE_URL
});

axiosPrivate.interceptors.request.use(async (config) => {
    const token = await getToken();
    config.headers!.Authorization = token ? `Bearer ${token}` : '';
    config.headers!['Content-Type'] = 'application/json;charset=UTF-8';
    return config;
});
